import React, { useContext, useEffect, useState } from 'react'
import { Input, Spin, InputNumber, App } from "antd";
import { API, Enum } from "../../../resources/constants"
import language from "../../../resources/languages/fa_IR"

// Contexts
import AxiosContext from "../../../contexts/axios";

// Interfaces
import { AxiosError } from "../../../interfaces/axios"
import { AntTableParams } from "../../../interfaces/ant"
import type { TablePaginationConfig } from 'antd/es/table'

const { Pages: { BasicInformation: { Province: ProvinceLanguage } }, Share, Validation, Message: MessageLanguage } = language
const { BASIC_INFORMATION_PROVINCE_ID, BASIC_INFORMATION_PROVINCE_CREATE, BASIC_INFORMATION_PROVINCE_UPDATE } = API
const { Message } = Enum

interface ProvinceType {
    id: string,
    name: string,
    createdAt: Date,
    updatedAt: Date,
}
export default function CURecord(props: { Form: any, form: any, record: { id: string }|null, getProvinces: (params: AntTableParams) => void, pagination: TablePaginationConfig }) {
    const { Form, form, record, getProvinces, pagination } = props

    const { axios } = useContext(AxiosContext)
    const [loadingRecord, setLoadingRecord] = useState<boolean>(true);
    const { message } = App.useApp();

    useEffect(() => {
        form.resetFields()
        initialAPI().then(response => response)
    }, []);

    const initialAPI = async () => {
        await getRecord()
    }

    const getRecord = async () => record ? axios.get(BASIC_INFORMATION_PROVINCE_ID + record.id).then((response: { data: ProvinceType }) => {
        const { data: province } = response
        form.setFieldsValue(province)
        setLoadingRecord(false)
    }).catch((error: AxiosError) => {
        const { response: { data } } = error;
        // @ts-ignore
        message.error(MessageLanguage[data.message]).then(response => response )
    }) : setLoadingRecord(false)

    const onFinish = ((province: {}) => {
        setLoadingRecord(true)
        if (record) {
            axios.patch(BASIC_INFORMATION_PROVINCE_UPDATE + record.id, province).then((response: {}) => {
                message.success(MessageLanguage[Message.UPDATE_RECORD]).then(response => response)
                setLoadingRecord(false)
                const { current, pageSize } = pagination
                getProvinces({ page: current, limit: pageSize })
            }).catch((error: AxiosError) => {
                const { response: { data } } = error;
                // @ts-ignore
                message.error(MessageLanguage[data.message]).then(response => response)
                setLoadingRecord(false)
            })
        } else {
            axios.post(BASIC_INFORMATION_PROVINCE_CREATE, province).then((response: {}) => {
                message.success(MessageLanguage[Message.CREATE_RECORD]).then(response => response)
                form.resetFields()
                setLoadingRecord(false)
                const { current, pageSize } = pagination
                getProvinces({ page: current, limit: pageSize })
            }).catch((error: AxiosError) => {
                const { response: { data } } = error;
                // @ts-ignore
                message.error(MessageLanguage[data.message]).then(response => response)
                setLoadingRecord(false)
            })
        }
    })


    return (
        <Spin spinning={loadingRecord} tip={Share.loading} size="large">
            <Form form={form} name="cu-record" onFinish={onFinish} style={{ margin: '25px 0 10px 0'}}>
            <Form.Item
                label={ProvinceLanguage.name}
                name="name"
                hasFeedback
                rules={[
                    { required: true, message: `${ProvinceLanguage.name} ${Validation.required}` },
                ]}
            >
                <Input placeholder={ProvinceLanguage.name} />
            </Form.Item>
        </Form>
        </Spin>
    )
}
